var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createClient } from 'contentful';
var DEFAULT_CONTENTFUL_SPACE = 'norgcvq7fq7t'; // cspell:disable-line
var DEFAULT_CONTENTFUL_ENVIRONMENT = 'master';
var DEFAULT_CONTENTFUL_ACCESS_TOKEN = '5TSrT3oNlfaGDqL1TGs1XwJwP6lFVLe82Q8X699Nn3c'; // cspell:disable-line
var ContentfulBackend = /** @class */ (function () {
    function ContentfulBackend() {
    }
    ContentfulBackend.prototype.init = function (_services, options) {
        if (options === void 0) { options = {}; }
        this.client = createClient(__assign({ space: DEFAULT_CONTENTFUL_SPACE, environment: DEFAULT_CONTENTFUL_ENVIRONMENT, accessToken: DEFAULT_CONTENTFUL_ACCESS_TOKEN }, options));
    };
    ContentfulBackend.prototype.read = function (language, namespace, callback) {
        this.getTranslations({
            locale: language,
            'fields.namespace[in]': namespace,
            content_type: 'translation',
            limit: 1000
        })
            .then(function (items) { return items.reduce(function (acc, entry) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[entry.fields.key] = entry.fields.text, _a)));
        }, {}); })
            .then(function (items) { return callback(null, items); })["catch"](function (e) { return callback(e, null); });
    };
    ContentfulBackend.prototype.readMulti = function (languages, namespaces, callback) {
        var _this = this;
        // get namespaces for all languages
        // contentful doesn't allow to use multiple locales in one query
        Promise.all(languages.map(function (lang) {
            return _this.getTranslations({
                locale: lang,
                'fields.namespace[in]': namespaces.join(','),
                content_type: 'translation',
                limit: 1000
            });
        }))
            // parse
            .then(function (d) {
            var translations = d.reduce(function (translations, items) {
                var translation = items.reduce(function (translation, item) {
                    if (!translation[item.sys.locale]) {
                        translation[item.sys.locale] = {};
                    }
                    translation[item.sys.locale][item.sys.id] = item.fields;
                    return translation;
                }, {});
                return __assign(__assign({}, translations), translation);
            }, {});
            callback(null, translations);
        })["catch"](function (e) { return callback(e, null); });
    };
    ContentfulBackend.prototype.getTranslations = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var items, skip, total, entries;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        items = [];
                        skip = 0, total = 0;
                        _a.label = 1;
                    case 1: return [4 /*yield*/, this.client.getEntries(__assign({ skip: skip }, query))];
                    case 2:
                        entries = _a.sent();
                        items.push.apply(items, entries.items);
                        total = entries.total;
                        skip = items.length;
                        _a.label = 3;
                    case 3:
                        if (skip < total) return [3 /*break*/, 1];
                        _a.label = 4;
                    case 4: return [2 /*return*/, items];
                }
            });
        });
    };
    // https://github.com/i18next/i18next/issues/1440
    ContentfulBackend.type = 'backend';
    return ContentfulBackend;
}());
export { ContentfulBackend };
